var map = {
	"./Page.js": 49052,
	"./Page.vue": 79902,
	"./PageOverlay.vue": 95637,
	"./Selection.js": 691,
	"./State.js": 66053,
	"./bootstrapper.js": 4237,
	"./editors/AbstractPanel.vue": 22409,
	"./editors/BlockEditor.vue": 69965,
	"./editors/Editor.vue": 30635,
	"./editors/inputs/ColorsInput.vue": 3099,
	"./editors/inputs/SwitchInput.vue": 74438,
	"./editors/inputs/TextInput.vue": 27669,
	"./editors/inputs/WebsitePageInput.vue": 59578,
	"./editors/loop/LoopEditor.vue": 15739,
	"./editors/loop/LoopItemEditor.vue": 29159,
	"./editors/loop/LoopItemPanel.vue": 11377,
	"./editors/loop/LoopPanel.vue": 31061,
	"./editors/loop/owlCarousel/LoopEditor.vue": 86634,
	"./editors/loop/owlCarousel/LoopItemEditor.vue": 40149,
	"./editors/loop/owlCarousel/LoopItemPanel.vue": 60273,
	"./editors/panels/FloatingPanel.vue": 65745,
	"./editors/panels/Tabs.vue": 22566,
	"./pageOverlay/OverviewRootBlockToolbar.vue": 48109,
	"./pageOverlay/SelectionAlternatives.vue": 11255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26185;